import * as d3 from 'd3'
export default {
  methods: {

    draw_ViewBox() {
      let viewbox = this.scroll.viewbox
      
      this.canvasContents = this.svg
      .append('g')
      .attr('transform', `translate(${viewbox.x}, ${viewbox.y})`)
      .attr('font-family', 'roboto')

      // CLIP PATH -----------------------------------------------------------------------------
      this.canvasContents
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('width', viewbox.width).attr('height', viewbox.height)

      let clippedGroup = this.canvasContents
      .append('g')
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

      // clippedGroup // Stroke for temporary
      // .append('rect')
      // .attr('stroke', '#757575').attr('stroke-width', 0.5)
      // .attr('width', viewbox.width).attr('height', viewbox.height).attr('fill', 'none')
      
      this.draw_DataTable(clippedGroup)
    },


    draw_Scrollbar() {
      let bar = this.scroll.bar
      let canvasScroll = this.canvasContents
      .append('g')
      .attr('id', `CANVAS_SCROLL_${this.localId}`)
      .attr('transform', `translate(${this.scroll.viewbox.width}, ${0})`)

      canvasScroll
      .append('rect')
      .attr('width', bar.width).attr('height', this.scroll.viewbox.height)
      .attr('fill', '#E0E0DF').attr('opacity', .3)

      canvasScroll
      .append('rect')
      .attr('id', `SCROLL_BAR_${this.localId}`)
      .attr('width', bar.width).attr('height', this.scroll.bar.size)
      .attr('fill', bar.color).attr('opacity', bar.opacity)
      .call(
        d3.drag()
        .on('drag', (event) => this.dragging(event))
      )
    },


    dragging(event) {
      let bar = this.scroll.bar
      let viewbox = this.scroll.viewbox
      let content = this.scroll.content
      let wheel = this.scroll.wheel
      
      bar.y = bar.y + event.dy

      if(bar.y < 0) bar.y = 0
      if((bar.y + bar.size) > viewbox.height) bar.y = bar.space
      
      d3.select(`#SCROLL_BAR_${this.localId}`).attr('y', bar.y)

      let bar_ratio = bar.y / bar.space
      content.y = viewbox.space * bar_ratio
      d3.select(`#CONTENTS_${this.localId}`).attr('transform', `translate(${0}, ${-content.y })`)
      wheel.count = -parseInt(content.y / 30)
    },

  }
}